export enum configsFormFields {
  configs = 'configs',
}
